import * as angular from 'angular';

import { BadActorsWidgetBase, IBadActorsWidgetOptions } from './badActorsWidgetBase';
import { IWidgetConfiguration } from '..//models';
import { tagDefaultState } from '../../common/';
import { IInputValuesService } from '../../services';

export class BadActorsWidget extends BadActorsWidgetBase {
    configuration: any;
    errorSearch = 'bad';
    highlights = ['A bar chart of bad tags'];
    name = 'Bad tags - Most frequent issues';
    options: IBadActorsWidgetOptions;
    type = 'badActors';

    constructor(private _$state: angular.ui.IStateService,
        private _inputValuesService: IInputValuesService,
        config?: IWidgetConfiguration) {
        super(config);
        this.options = {
            seriesClick: (d, i) => {
                this._$state.go(tagDefaultState, { tagDefinitionGuid: d.guid });
            }
        };
        this.configuration = {
            labels: []
        };
    }

    readData(guid?: string): angular.IPromise<any> {
        return this._inputValuesService.getNumberOfBadValuesPerTag(guid);
    }
}